import styled from 'styled-components';
import { Grid, ListItem, Typography } from '@material-ui/core';
import { AddToQueue } from '@material-ui/icons';

export const MainWrapper = styled(Grid)`
    height: 100%;
    background: ${props => props.theme.secondary.main};
`;
export const WrapperItem = styled(Grid)`
    padding-right: 1%;
`;
export const Container = styled.div`
    height: 100%;
    background-color: ${props => props.theme.white.light};
    display: flex;
    flex-direction: column;
`;
export const Header = styled(Grid)`
    height: 64px;
    background-color: ${props => props.theme.header};
    align-items: center;
    box-shadow: 0px 0px 8px ${props => props.theme.secondary.main};
`;
export const HeaderChild = styled(Grid)<{flex: number}>`
    flex: ${props => props.flex};
    display: flex;
    align-items: flex-end;
    padding-left: 2%;
`;
export const MatterLabel = styled.p<{isHeader?: boolean}>`
    flex: 2;
    background-color: ${props => props.isHeader && props.theme.tableHeader};
    color: ${props => props.isHeader && props.theme.white.light};
    padding: 8px;
`;
export const MatterHeaderLabel = styled(Typography)`
    flex: 2;
`;
export const TrackBtn = styled(AddToQueue)`
    margin-right: 5%;
`;
export const Loading = styled.div`
    background-color: ${props => props.theme.white.main};
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;
export const MatterListItem = styled(ListItem)`
    padding: 0 16px !important;
`;